import { Component, OnInit } from '@angular/core';
import {
    AuthenticationService,
    button,
    BUTTONS,
    ChassisFormHandler,
    DatatableQueryService,
    LoaderService,
    PluginDataInterface,
    RouteService,
    ToastService2,
    ToolbarService,
    trans
} from '@kaiser-software/chassis-core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ObservationService } from '../../../services/observation.service';
import { ObservationModel } from '../../../models/observation.model';
import { Observable, Observer, Subject } from 'rxjs';
import { EditObservationFormFactory } from '../../../services/edit-observation-form.factory';
import { filter, finalize, first } from 'rxjs/operators';

const SAVE_AND_COMPLETE = 'save-and-complete';

@Component({
    selector: 'app-observations-edit',
    templateUrl: 'edit.component.html',
    styleUrls: ['edit.component.scss'],
    providers: [
        EditObservationFormFactory
    ],
})
export class ObservationsEditComponent implements OnInit {

    public form: ChassisFormHandler;

    /**
     * The observation model subject.
     *
     * @type {ReplaySubject<any>}
     */
    protected $observation: Subject<ObservationModel> = new ReplaySubject(1);

    protected pluginData: PluginDataInterface;

    protected loader;

    constructor(
        protected observationService: ObservationService,
        protected activatedRoute: ActivatedRoute,
        protected routeService: RouteService,
        protected toolbarService: ToolbarService,
        protected toolbar: ToolbarService,
        protected editObservationFormFactory: EditObservationFormFactory,
        protected toastService: ToastService2,
        protected loaderService: LoaderService,
        protected authenticationService: AuthenticationService,
        protected router: Router,
        protected datatableQueryService: DatatableQueryService,
    ) {
        //
    }

    public ngOnInit(): void {
        this.loader = this.loaderService.create();

        this.setUpForm();
        this.setupPlugins();
        this.setUpToolbar();
        this.loadModel();
    }

    protected loadModel(): void {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.observationService
                .oneWith(
                    params['observation'],
                    ['category', 'category.category', 'account']
                )
                .subscribe((observation: ObservationModel) => {
                    console.log(observation);
                    this.$observation.next(observation);
                });
        });
    }

    protected setUpForm(): void {
        this.form = this.editObservationFormFactory.create(
            this.$observation
        );
    }

    protected setupPlugins(): void {
        this.pluginData = {
            inputs: {
                form: this.form,
                model: this.$observation,
                modelSubject: this.$observation,
            }
        };
    }

    protected setUpToolbar(): void {
        this.toolbarService.remove(BUTTONS.SAVE_BACK_TO_INDEX.NAME);

        this.addToolbarCancelButton();
        this.addSaveAndCompleteToolbarButton();
    }

    protected addToolbarCancelButton(): void {
        this.toolbarService.add(
            button(BUTTONS.BACK, {
                callback: () => {
                    this.routeBackToIndex();
                    // this.routeService.navigate(this.routePrefix + '.index');
                },
            })
        );
    }

    protected addSaveAndCompleteToolbarButton(): void {
        this.$observation
            .pipe(
                first(),
                filter((observation: ObservationModel) => {
                    return observation.getStatus() !== 'completed';
                })
            )
            .subscribe((observation: ObservationModel) => {
                this.toolbarService.add({
                    name: SAVE_AND_COMPLETE,
                    text: 'Save and complete',
                    classes: 'btn-success',
                    icon: 'fal fa-check',
                    callback: () => {
                        this.updateObservationAndComplete(observation)
                    },
                    disabled: () => {
                        return this.loader.isLoading();
                    },
                    loader: () => {
                        return this.loader.isLoading();
                    }
                });
            });
    }

    protected updateObservationAndComplete(observation): void {
        this.loader.start();

        observation.fill({
            'status': 'completed',
        });

        this.sendUpdateObservationRequest(observation)
            .pipe(
                finalize(() => {
                    this.loader.stop();
                })
            )
            .subscribe((o) => {
                this.$observation.next(o);

                this.toolbarService.remove(SAVE_AND_COMPLETE);
            })
    }

    protected sendUpdateObservationRequest(observation: ObservationModel): Observable<ObservationModel> {
        return new Observable((observer: Observer<ObservationModel>) => {
            const params = {
                include: 'category.category',
            };

            const request = this.observationService.put(
                observation.id,
                observation.plain(),
                params
            );

            request
                .subscribe((result) => {
                    this.toastService.success(
                        trans('Successfully completed the observation')
                    );

                    observer.next(result);
                }, (error) => {
                    observation.fill({
                        status: 'open'
                    });

                    this.toastService.error(error.message);

                    observer.error(error);
                }, () => {
                    observer.complete();
                });
        });
    }

    protected async routeBackToIndex(): Promise<void> {
        const route = this.routeService.route(
            'observations.index'
        );

        await this.router.navigate([route], {
            queryParams: this.datatableQueryService.getLastQueryParams(),
        });
    }
}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/pages/observations/edit/edit.component.ts